// extracted by mini-css-extract-plugin
export default {"enabledCustomersOfTheDay":"customer-selections-button__enabledCustomersOfTheDay___a25Cm","disabledCustomersOfTheDay":"customer-selections-button__disabledCustomersOfTheDay___M00XK"};